<template>
  <div class="status-change-dropout-not-audit-final-batch-reject">
    <div class="main-cont"
         v-loading="committing"
         element-loading-text="数据提交中，请稍等...">
      <el-form size="mini"
               label-position="top"
               label-suffix="：">
        <el-form-item label="驳回理由">
          <el-input v-model="form.auditRemark"
                    type="textarea"
                    maxlength="200"
                    show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button size="mini"
                 type="primary"
                 :disabled="committing"
                 @click="submitApply">提交审核</el-button>
      <el-button size="mini"
                 type="default"
                 @click="handleClose">取消操作</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusChangeDropoutNotAuditFinalBatchReject',
  inject: ['$grid'],
  props: {
    preHandleParams: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      form: {
        auditRemark: ''
      },
      committing: false
    }
  },
  methods: {
    submitApply () {
      let form = this.form
      if (form.auditRemark) {
        this.handleReject(form)
      } else {
        this.$confirm('未填写驳回理由，确认继续吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.handleReject(form)
        }).catch(() => {})
      }
    },
    handleReject (form) {
      this.committing = true
      this.$ajax({
        url: '/workspace/manager/status/change/auditDropout/final/batchRejected',
        method: 'post',
        data: this.$qs.stringify(this.$extend(this.preHandleParams(), form), {
          arrayFormat: 'repeat'
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              if (this.$grid) {
                this.$grid.$emit('state-change')
              }
              this.$nextTick(() => {
                this.$emit('hidePopoverAndRefresh')
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.committing = false
      })
    },
    handleClose () {
      this.$emit('hidePopover')
    }
  }
}
</script>

<style lang="scss">
  .status-change-dropout-not-audit-final-batch-reject {
    & > .main-cont {
      padding: 10px 15px;
      .el-form {
        .el-form-item {
          margin-bottom: 10px;
          .el-form-item__label {
            color: #909399;
            font-size: 12px;
            padding-bottom: 2px;
          }
        }
      }
    }
    & > .footer {
      height: 52px;
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      text-align: center;
      line-height: 50px;
    }
  }
</style>
